import { createReducer } from 'typesafe-actions';
import { repos } from './actions';
import { GetReposResponse } from './types';
import { RequestStatus } from 'utils/types';

type State = {
  data: GetReposResponse[] | null;
  message: string | null;
  status: RequestStatus | null;
};

const initialState: State = {
  data: null,
  message: null,
  status: null,
};

const reposReducer = createReducer(initialState)
  .handleAction(repos.request, (state) => ({
    ...state,
    data: null,
    message: null,
    status: RequestStatus.PENDING,
  }))
  .handleAction(repos.success, (state, action) => ({
    ...state,
    data: [
      ...action.payload,
    ],
    message: null,
    status: RequestStatus.SUCCESS,
  }))
  .handleAction(repos.failure, (state, action) => ({
    ...state,
    data: null,
    message: action.payload.message,
    status: RequestStatus.FAILED,
  }));

export default reposReducer;
